import ImagePicker from 'antd-mobile/lib/image-picker';
export default ImagePicker;



// WEBPACK FOOTER //
// ./components/image-picker/index.tsx